import React from "react";
import { withNavBars } from "../../HOCs";
import ViewMaintenancePlanner from "./viewMaintenancePlanner";

class ViewMaintenancePlannerParent extends React.Component {
    render() {
        return <ViewMaintenancePlanner  {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(ViewMaintenancePlannerParent, props);